import React from 'react';

export function useClickOutside<T extends HTMLElement>(
    onClickOutside: () => void,
) {
    const containerRef = React.useRef<T>(null);

    React.useEffect(() => {
        const onClick = (ev: MouseEvent | TouchEvent) => {
            const clickedEle = ev.target as Element | null;
            const isShadowRoot = !!clickedEle?.shadowRoot;
            const isClickOutside = isShadowRoot
                ? !clickedEle.shadowRoot.contains(containerRef.current)
                : !containerRef.current?.contains(clickedEle);
            isClickOutside && onClickOutside();
        };

        document.addEventListener('click', onClick);

        return function cleanup() {
            document.removeEventListener('click', onClick);
        };
    }, [containerRef, onClickOutside]);

    return containerRef;
}
